var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueApexCharts',{attrs:{"width":"500","type":"bar","options":_vm.pieChartOptions,"series":_vm.chartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }